import { Box, List } from "@mui/material";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import NavSectionItem from "./NavSectionItem";

export default function NavSection({ navConfig }) {
  const [searchInput, setSearchInput] = useState("");

  const getNavItemsList = (array, query) => {
    if (query) {
      const _nav_list = array
        .map((data) => {
          const is_main =
            data.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
          const match_child = data.child_options?.filter(
            (item) =>
              item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
          );

          if (is_main) {
            return data;
          } else if (match_child?.length > 0) {
            return {
              ...data,
              child_options: match_child,
            };
          }
          return null;
        })
        .filter(Boolean);
      return _nav_list;
    }

    return array;
  };

  return (
    <Box>
      <div className="my-1 p-2">
        <div className="sidebar-search-box">
          <Icon
            fontSize={20}
            className="sidebar-search-icon"
            icon="akar-icons:search"
          />
          <input
            className="sidebar-search-input"
            type="text"
            placeholder="Search"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </div>
      </div>
      <List disablePadding>
        {getNavItemsList(navConfig, searchInput).map((item, i) => {
          return (
            <NavSectionItem key={i} data={item} searchInput={searchInput} />
          );
        })}
      </List>
    </Box>
  );
}
